// color scale based on percentage
// borrowed from https://gist.github.com/mlocati/7210513
export const percent2color = (percent: number): string => {
  let red = 0;
  let green = 0;
  const blue = 0;

  if (percent < 50) {
    red = 255;
    green = Math.round(5.1 * percent);
  } else {
    green = 255;
    red = Math.round(510 - 5.1 * percent);
  }
  const h = red * 0x10000 + green * 0x100 + blue * 0x1;
  return `#${`000000${h.toString(16)}`.slice(-6)}`;
};
